import ServiceContainer from "./service-container";

const context = require.context("../../../app/services", true, /\.js$/);

const serviceInitPromises = context.keys().map(async (key) => {
  const mod = context(key);
  const ServiceClass = mod.default;
  if (typeof ServiceClass === "function") {
    const serviceName = key.replace(/^\.\/|\.js$/g, "");
    ServiceContainer.register(serviceName, ServiceClass);

    // If the service has an optional async `init()` method, await it
    if (typeof ServiceClass.init === "function") {
      await ServiceClass.init();
    }
  }
});

export default Promise.all(serviceInitPromises);
